import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdRelationshipChartsDataContext } from './hooks/useHouseholdRelationshipChartsDataContext';

export const RegisteredPersonFamilyResponsableRelation = () => {
    const { chartData } = useHouseholdRelationshipChartsDataContext();

    return (
        <SimpleBars
            title={'Relção da Pessoa Cadastrada com o Responsável Familiar'}
            horizontal={true}
            subtitles={chartData?.registeredPersonFamilyResponsableRelation?.map(
                (item) => item.description
            )}
            values={chartData?.registeredPersonFamilyResponsableRelation?.map(
                (item) => item.total || 0
            )}
        />
    );
};
